import { f as filterConfigForEnv, h as hosts$1 } from './index-9be0dea2.esm.js';
export { e as endpoints, g as getConfigValueFromEnv, h as prod } from './index-9be0dea2.esm.js';

/** Will reverse proxy/mock all local & pp api via moxy */
var moxy = '//newprodpp.goibibo.com/moxy';
var hosts = {
  goibibo: '//www.goibibo.com',
  pokus: moxy,
  recommendEarnUrl: moxy,
  skywalker: moxy,
  voyagerX: moxy,
  voyager: moxy,
  recentSearchPush: moxy,
  gdpr: moxy,
  appBannerUrl: moxy,
  userGeoLocation: moxy,
  configStore: moxy,
  argus: moxy,
  loyaltyUserInfo: moxy,
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: moxy
};

/**
 * Default index gives the client side api configs
 * eg:
 * import getConfig from '@growth/api-configs'
 */
var configs = {
  local: hosts,
  prod: hosts$1
};

var getConfig = function getConfig(env) {
  var c = filterConfigForEnv(configs, env);
  return c;
};

export { getConfig, hosts as local };
